export const AP_TRAINING_CATALOG_OBJECT_LOADER = {
  desktop: `<div class="cui cui-grid cui-container">
  <div class="cui-skeleton-paragraph -spacing--top-40 -spacing--bottom-40">
    <div class="cui-skeleton-paragraph__content" style="width: min(405px, 100%)">
      <div class="cui-skeleton__item" style="height: 24px"></div>
    </div>
  </div>
  <div class="cui-skeleton-heading -size--large">
    <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-row -spacing--top-40 -spacing--bottom-120">
    <div class="cui-col-lg-7">
      <div class="cui-skeleton-heading -size--medium">
        <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--top-40">
        <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--medium -spacing--top-40">
        <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 109px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 109px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
        <div class="cui-skeleton__item" style="width: 100%; height: 109px"></div>
      </div>
    </div>
    <div class="cui-col-lg-5 cui-col-xl-4">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 421px"></div>
      </div>
    </div>
  </div>
</div>
`,
  mobile: `
<div class="cui cui-grid cui-container">
<div class="cui-skeleton-paragraph -spacing--top-16 -spacing--bottom-16">
  <div class="cui-skeleton-paragraph__content" style="width: min(405px, 100%)">
    <div class="cui-skeleton__item" style ="height: 16px"></div>
  </div>
</div>
<div class="cui-skeleton-heading -size--large -spacing--top-40">
  <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
    <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
  </div>
</div>
<div
  class="cui-row -spacing--top-24 -spacing--bottom-64"
  style ="flex-direction: column-reverse"
>
  <div class="cui-col-lg-7">
    <div class="cui-skeleton-heading -size--medium">
      <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>
    <div class="cui-skeleton-heading -size--medium -spacing--top-24">
      <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
          <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>
    <div class="cui-skeleton-heading -size--medium -spacing--top-24">
      <div class="cui-skeleton-heading__content" style="width: min(730px, 100%)">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      </div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--top-24 -spacing--top-16">
        <div class="cui-skeleton__item" style="width: 100%; height: 109px"></div>
      </div>
  </div>
  <div class="cui-col-lg-5 cui-col-xl-4 -spacing--bottom-24">
    <div class="cui-skeleton-rectangle -is--block">
      <div class="cui-skeleton__item" style="width: 100%; height: 290px"></div>
    </div>
  </div>
</div>
</div>
`
};
